<template>
    <div class="shop__deliveryperiod shop__options-block">
        <div class="shop__options-block-input">
            <SelectWithLabel :value="SelectedDeliveryPeriod.id" @change="updateDeliveryPeriod" :options="AvailableDeliveryPeriods" :label="Strings['Shop.LabelDeliveryPeriod']" :disabled="AvailableDeliveryPeriods.length <= 1" />
        </div>
        <div class="shop__options-block-desc">
            <!-- hidden label for spacing -->
            <label class="migrol-form__input-label migrol-form__input-label--invisible">{{Strings['Shop.LabelDeliveryPeriod']}}</label>
            <div v-if="ShowExpressForMultipleUPMessage" v-html="Strings['Shop.ExpressForMultipleUnloadingPoints']"></div>
            <div v-if="!ExpressSelected"><v-runtime-template :template="DeliveryPeriodDetails" /></div>
            <div v-if="ExpressSelected"><v-runtime-template :template="DeliveryPeriodExpressDetails" /></div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import { DeliveryPeriodTypes } from '@/utils/constants'
    import DeliveryPeriod from '@/models/DeliveryPeriod'
    import Transaction from '@/models/Transaction'
    import Position from '@/models/Position'
    import VRuntimeTemplate from "v-runtime-template"

    export default {
        props: {
            mode: {
                type: String,
                required: true
            }
        },
        computed: {
            ...mapState([
                'Strings'
            ]),
            AvailableDeliveryPeriods() {
                return DeliveryPeriod
                    .query()
                    .where(p => { return this.CurrentTransactionPositions.length == 1 || p.deliveryPeriodType != DeliveryPeriodTypes.Express })
                    .orderBy('sortOrder', 'asc')
                    .get()
                    .map((per) => { return { text: per.displayText, id: per.id } });
            },
            CurrentTransaction() {
                return Transaction.query().with('deliveryPeriod').first();
            },
            CurrentTransactionPositions() {
                return Position.query().where('transaction_id', this.CurrentTransaction.id).get();
            },
            SelectedDeliveryPeriod() {
                return this.CurrentTransaction.deliveryPeriod;
            },
            ShowExpressForMultipleUPMessage() {
                //if we have less than 2 UP, express can be picked anyway (if it is available)
                if (this.CurrentTransactionPositions.length < 2)
                    return false;

                //more than 1 UP -> check if express is even available. if so, show the message.
                let express = DeliveryPeriod.query().where('deliveryPeriodType', DeliveryPeriodTypes.Express).first();
                return (express != null);
            },
            DeliveryPeriodDetails() {
                switch (this.mode) {
                    case 'BnT':
                        return '<span>' + this.Strings['Shop.RegularDeliveryInfo_BrennTreibstoffe'] + '</span>';
                    case 'SnA':
                        return '<span>' + this.Strings['Shop.RegularDeliveryInfo_ServicesAnlagen'] + '</span>';
                    default:
                        return null;
                }

            },
            DeliveryPeriodExpressDetails() {
                return '<span>' + this.Strings['Shop.ExpressDeliveryInfo'] + '</span>';
            },
            ExpressSelected() {
                return this.SelectedDeliveryPeriod.deliveryPeriodType === DeliveryPeriodTypes.Express;
            }
        },
        watch: {
            CurrentTransactionPositions(newPositions) {
                if (newPositions.length > 1 && this.SelectedDeliveryPeriod.deliveryPeriodType === DeliveryPeriodTypes.Express) {
                    //multiple UPs are not allowed to have express -> set it to the first allowed value
                    let defaultDeliveryPeriod = DeliveryPeriod.query().where('deliveryPeriodType', DeliveryPeriodTypes.Prompt).first();
                    if (defaultDeliveryPeriod === null) {
                        defaultDeliveryPeriod = DeliveryPeriod.query().where('deliveryPeriodType', DeliveryPeriodTypes.Period).orderBy('id').first();
                    }

                    Transaction.update({
                        id: this.CurrentTransaction.id,
                        deliveryPeriod: defaultDeliveryPeriod
                    });
                }
            }
        },
        methods: {
            updateDeliveryPeriod(newDeliveryPeriodId) {
                Transaction.update({
                    id: this.CurrentTransaction.id,
                    deliveryPeriod: DeliveryPeriod.find(newDeliveryPeriodId)
                });
            }
        },
        components: {
            VRuntimeTemplate
        }
    };
</script>